import React, { useState, useCallback, FormEvent } from 'react';
import UploadFiles from '../UploadFiles';
import { uuid } from 'uuidv4'
import filesize from 'filesize';
import FileList from '../FileList';
import api from '../../Services/api';
import { useAblContext } from '../../Hooks/useAblContext';
import Input from '../Input';
import { useHistory } from 'react-router-dom';
import Modal from 'react-modal';
import phoneFormat from '../../Utils/phoneFormat';

interface DocumentUploadProps {
  onSuccess: Function,
}

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width: '773',
    height: '550',
  }
};

const RegisterForm: React.FC<DocumentUploadProps> = ({ onSuccess }) => {
  const [files, setFiles] = useState<any[]>([]);
  const [singleFile, setSingleFile] = useState<any>({});

  const [debutDate, setDebutDate] = useState('');
  const [movieTitle, setMovieTitle] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [producerName, setProducerName] = useState('');
  const [cpbAncine, setCpbAncine] = useState('');
  const [ancineRegister, setAncineRegister] = useState('');
  const [email, setEmail] = useState('');
  const [type, setType] = useState('');
  const [phone, setPhone] = useState('');
  const [responsibleProducerName, setResponsibleProducerName] = useState('');
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [showLoading, setShowLoading] = useState(false);
  const abl = useAblContext();
  const history = useHistory();

  const handleAcceptFile = async (acceptFile: any) =>{
    acceptFile.map((file: any) => (
      setSingleFile({
        file,
        id: uuid(),
        name: file.name,
        readableSize: filesize(file.size),
        preview: URL.createObjectURL(file),
        progress: 0,
        uploaded: false,
        error: false,
        url: null
      })))
    }

  React.useEffect(() => {
    let copyFiles = files;
    copyFiles.push(singleFile)
    setFiles([...copyFiles]);
  }, [singleFile])



  const processUpload = () => {
    const data = new FormData();
    data.append('email', email);
    data.append('ancineRegister', ancineRegister );
    data.append('cpbAncine', cpbAncine );
    data.append('movieTitle', movieTitle );
    data.append('movieName', movieTitle);
    data.append('producerName', producerName);
    data.append('responsibleProducerName', responsibleProducerName);
    data.append('phone', phone);
    data.append('launchDate', debutDate);

    data.append('type', type);

    files.forEach((file, _) => {
      if(file.id){
        data.append(`files`, file.file, file.name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
      }
    });

    api.post('company', data, { headers: {
      authorization: abl.token },

    }).then(response => {
      setEnableSubmit(true);
      onSuccess();
      if(response.data)
        setShowLoading(false);
        history.push('thank-you');
    }).catch(err => {
      setShowLoading(false);
      alert('Erro ao realizar cadastro, verifique com o administrador do sistema ou tente novamente mais tarde.')
      console.log(err)

    })
  }

  const handleOnPress = (e: FormEvent) => {
    setEnableSubmit(false);
    e.preventDefault();
    if(!validate()){
      alert('Erro ao realizar cadastro, verifique os campos digitados!');
      setEnableSubmit(true);
      return;
    }
    setShowLoading(true);
    processUpload();
  };

  const validate = () => {
    let regexp: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if(!email.length || !ancineRegister.length
     || !cpbAncine.length
     || !movieTitle.length
     || !producerName.length
     || !regexp.test(email)
     || !files.length
     || !type.length
     ){
      alert('Alguma coisa está faltando :( verifique os campos que foram digitados')
      return false;
    }

    let valido = false
    if (files.length > 0) {
      files.forEach((file, _) => {
        if (file.name != undefined) {
          valido = true
        }
      });
    }

    return valido
    //return true;
  }

  return(
        <div className="conteudo">
          <Modal
            isOpen={showLoading}
            style={customStyles}
            contentLabel="Adicionar usuário"
          >
            <img src="img/loading.gif" alt="loading"  width={250}/>
          </Modal>
          <h1>Ficha de inscrição</h1>
          <div className="container">
			      <p className="titulo">INSCRIÇÕES ABERTAS ATÉ 20 de AGOSTO DE 2024</p>
        <p>
        Caso a estreia comercial do filme ocorra em datas posteriores ao encerramento da chamada para a inscrição pela Academia (20 de Agosto de 2024), a empresa produtora responsável deverá enviar uma carta à Academia Brasileira de Cinema e Artes Audiovisuais, assinada, conjuntamente com o distribuidor do filme, especificando a data de estreia prevista e cidade no ato da inscrição até o prazo máximo estabelecido pela Ampas na <a href="https://academiabrasileiradecinema.com.br/regra-quinze-regras-especiais-para-ooscar-de-longa-metragem-internacional-2025/" target="_blank">Regra 15</a>.
        <br />
                Caso os produtores da obra não sejam associados à Academia Brasileira de Cinema, haverá cobrança de taxa de inscrição no valor de R$1.000,00 (Hum mil reais)*. Para informações sobre o pagamento da taxa entre em contato com academia@academiabrasileiradecinema.com.br
          </p>
              <form action="">
                <div className="row register">
                  <div className="col-md-4">
                    <Input
                      label="TÍTULO DO FILME"
                      name="razao"
                      value={movieTitle}
                      onChange={(e) => setMovieTitle(e.target.value)}
                      />
                  </div>

                  <div className="col-md-4">
                        <Input
                          label="CPB ANCINE"
                          name="bairro"
                          value={cpbAncine}
                          onChange={(e) => setCpbAncine(e.target.value)}
                        />
                    </div>

					            <div className="col-md-4">
                        <Input
                          label="DATA DE ESTREIA NO BRASIL"
                          type="date"
                          name="data"
                          value={debutDate}
                          onChange={(e) => setDebutDate(e.target.value)}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <Input
                          label="NOME DA PRODUTORA"
                          name="numero"
                          value={producerName}
                          onChange={(e) => setProducerName(e.target.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                          label="Nº REGISTRO NA ANCINE"
                          name="complemento"
                          value={ancineRegister}
                          onChange={(e) => setAncineRegister(e.target.value)}
                        />
                    </div>
                    <div className="col-md-4">
                      <label>Selecione os documentos</label>
              <UploadFiles onAcceptFile={handleAcceptFile} acceptFiles={['application/pdf', 'image/jpeg', 'image/png']} messageStrong={ "Clique aqui" } message={"e selecione os documentos comprobatórios da exibição comercial do filme, conforme especificado pela Regra 15 - Principalmente CPB e Borderô. Envie também os materiais de divulgação do filme: Fotos, release, cartaz e presskit."}
                        />
                        { !! files.length && <FileList files={files}/>}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label htmlFor="estado">SELECIONE O TIPO DE LANÇAMENTO:
                            <select value={type} name="lancamento" onChange={(e) => {
                              setType(e.target.value)
                            }} >
                                <option value="" disabled hidden>Seleciona uma opção</option>
                                { /* <option value="Digital" selected>Digital</option> */}
                                <option value="Sala de Cinema">Sala de Cinema</option>
                            </select>
                        </label>
                    </div>

                </div>
                <div className="row">
                <div className="col-md-12">
                <p style={{fontSize: 16, fontWeight: 'bold', color: 'red'}}>SÓ SERÃO ACEITAS INSCRIÇÕES FEITAS PELA EMPRESA PRODUTORA</p>
                </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <Input
                          label="NOME DO PRODUTOR RESPONSÁVEL"
                          name="name"
                          value={responsibleProducerName}
                          onChange={(e) => {
                            setResponsibleProducerName(e.target.value)
                          }}
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                          label="TELEFONE"
                          name="phone"
                          value={phone}
                          onChange={(e) => {
                            setPhone(phoneFormat(e.target.value))
                          }}
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                          label="EMAIL"
                          name="email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value)
                          }}
                        />
                    </div>
                </div>
                <div>
                As informações contidas neste formulário são de responsabilidade do(a) produtor(a) que inscreveu o filme. No ato do envio do formulário de inscrição, o candidato concorda que as informações no formulário estão corretas e de acordo com a Regra 15/Regras Especiais da Ampas.
                </div>
                <div className="botao" style={{marginTop: 10 }}>
                  <button type="button" className="btn btn-dark"  disabled={!enableSubmit} onClick={(e) => {setEnableSubmit(false); handleOnPress(e)}}>{enableSubmit ? "ENVIAR": "AGUARDE O TÉRMINO DO ENVIO" }</button>
                </div>
              </form>
          </div>
        </div>
  )
}

export default RegisterForm;
